/**
 * @file TypographyTitle.js
 * @description Componente que renderiza un título con un tamaño de fuente y un margen inferior personalizado.
 * @requires React, Box, Typography
 */

import React from 'react';
import Typography from '@mui/material/Typography';

/**
 * @function TypographyTitle
 * @description Componente que renderiza un título con un tamaño de fuente y un margen inferior personalizado.
 * @param {Object} props Propiedades del componente
 * @param {String} props.children Contenido del título
 * @param {String} props.variant Tamaño de fuente del título
 * @param {String} props.marginBottom Margen inferior del título
 * @returns {JSX.Element} Componente TypographyTitle
 */

const TypographyTitle = ({ children, variant, marginBottom, color }) => {
  return (
    <Typography
      variant={variant}
      sx={{
        marginBottom: marginBottom,
        fontWeight: 'bold',
        color: color ? color : 'primary.main',
      }}
    >
      {children}
    </Typography>
  );
}

export default TypographyTitle;